import { LabelsMap } from 'new/form/common/types';

import { mittweidaCompanyDetailsLabelsMap } from './sections/companyDetails/labels';
import { mittweidaCompletingCompanyDetailsLabelsMap } from './sections/completingCompanyDetailsSection/labels';

export const mittweidaCompanyLabelsMap: LabelsMap = {
  ...mittweidaCompanyDetailsLabelsMap,
  ...mittweidaCompletingCompanyDetailsLabelsMap,
};
